/* Gerenic library javascript file dealing with the viewport coordinates */
import Point from './point.js';
import Rect from './rect.js';

class Viewport {
  /**
   * Viewport constructor
   * @param {Rect} pzParentRect  The panzoom parent rect
   */
  constructor(pzParentRect) {
    this.pzParentRect = pzParentRect;
  }

  boardToViewport(pt) {
    return new Point(pt.x - this.vpRect.left, pt.y - this.vpRect.top);
  }

  viewportToBoard(pt) {
    return new Point(pt.x + this.vpRect.left, pt.y + this.vpRect.top);
  }

  /**
   * Calculates the scale and location in the board required to fit the board content to the viewport, taking into account the given margins
   * @param   {Array}   nodes     The elements, notes, jumpers that we need to fit, requires x, y, width, height properties
   * @param   {Object}  margins   The margins { top, left, bottom, right} for the content from the edge of the viewport
   * @param   {Number}  minScale  The minimum allowed scaling (null if there is none)
   * @param   {Number}  maxScale  The maximum allowed scaling (null if there is none)
   * @return  {Object}            The transform object { scale, x, y } to apply to panzoom matrix in order to fit content
   */
  fitContentToViewport(
    nodes,
    margins = { top: 0, left: 0, bottom: 0, right: 0 },
    minScale = null,
    maxScale = null
  ) {
    console.log('Fitting the following nodes to viewport:', nodes);
    const contentRect = Rect.boundingRect(
      nodes.map(
        node =>
          new Rect(node.x, node.x + node.width, node.y, node.y + node.height)
      )
    );
    if (!contentRect) return null;
    console.log('The content rectangle is:', contentRect);

    // Get the current viewport dimensions
    const marginHeight = margins.top + margins.bottom;
    const marginWidth = margins.left + margins.right;
    const viewPort = {
      height: this.pzParentRect.height - marginHeight,
      width: this.pzParentRect.width - marginWidth,
    };
    console.log('Current viewport dimensions:', viewPort);

    // Choose a scale that would fit the content either to viewport width or height
    const scaleY = viewPort.height / contentRect.height;
    const scaleX = viewPort.width / contentRect.width;
    let scale = Math.min(scaleY, scaleX);

    // Constrain the desired scale
    if (minScale) {
      scale = Math.max(scale, minScale);
    }
    if (maxScale) {
      scale = Math.min(scale, maxScale);
    }

    return {
      scale,
      x: contentRect.midpoint.x,
      y: contentRect.midpoint.y,
    };
  }
}

export default Viewport;
